import { ErrorHandler, Injectable } from '@angular/core';
import { PlayerServiceProvider } from '../../modules/core/services/player-service/player-service';
import { TrackJS } from 'trackjs';
import { ENVIRONMENT } from '../../../environments/environment';

@Injectable()
export class TrackJsErrorHandler implements ErrorHandler {
  constructor(private playerService: PlayerServiceProvider) {}

  handleError(error: any) {
    if (!ENVIRONMENT.onProd) console.error(error);

    // just to make sure, the userId is set if possible
    TrackJS.configure({ userId: this.playerService.account.login || '' });
    TrackJS.track(error.originalError || error);
  }
}



// WEBPACK FOOTER //
// ./src/providers/track-js-error-handler/track-js-error-handler.ts